// DebugErrorBoundary.tsx
import React from 'react';

export class DebugErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { error: Error | null }
> {
  state = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('🔥 ERROR BOUNDARY CAUGHT:', error);
    console.error('📍 COMPONENT STACK:', info.componentStack);
  }

  render() {
  if (this.state.error) {
    return <div>💥 Error de render (ver consola)</div>;
  }
  return this.props.children;
}
}
